import { StoreonModule } from "storeon";

export interface IReviewStore {
  reviewSelectionStore: IReviewStoreShape;
}

export interface IReviewStoreShape {
    isDirectPurchaseReminder: boolean;
    isEnrollmentAgreement: boolean;
    isBenefitsAndCoverage: boolean;
    isSBCDocument: boolean;
    SBCDocumentUrl: string;
}

export interface IReviewEvents {
  toggleDirectPurchaseReminder: undefined;
  toggleEnrollmentAgreement: undefined;
  toggleBenefitsAndCoverage: undefined;
  toggleSBCDocument: undefined;
  setSBCDocumentUrl: string;
}

const reviewSelectionStore: StoreonModule<IReviewStore, IReviewEvents> = (
  store
) => {
  store.on("@init", () => ({
    reviewSelectionStore: {
      isDirectPurchaseReminder: false,
      isEnrollmentAgreement: false,
      isBenefitsAndCoverage: false,
      isSBCDocument: false,
      SBCDocumentUrl: "",
    },
  }));
  store.on('toggleDirectPurchaseReminder', (state) => ({
    ...state,
    reviewSelectionStore: {
      ...state.reviewSelectionStore,
      isDirectPurchaseReminder: !state.reviewSelectionStore.isDirectPurchaseReminder
    },
  }));
  store.on('toggleEnrollmentAgreement', (state) => ({
    ...state,
    reviewSelectionStore: {
      ...state.reviewSelectionStore,
      isEnrollmentAgreement: !state.reviewSelectionStore.isEnrollmentAgreement
    },
  }));
  store.on('toggleBenefitsAndCoverage', (state) => ({
    ...state,
    reviewSelectionStore: {
      ...state.reviewSelectionStore,
      isBenefitsAndCoverage: !state.reviewSelectionStore.isBenefitsAndCoverage
    },
  }));
  store.on('toggleSBCDocument', (state) => ({
    ...state,
    reviewSelectionStore: {
      ...state.reviewSelectionStore,
      isSBCDocument: !state.reviewSelectionStore.isSBCDocument
    },
  }));
  store.on('setSBCDocumentUrl', (state, event) => ({
    ...state,
    reviewSelectionStore: {
      ...state.reviewSelectionStore,
      SBCDocumentUrl: event
    },
  }));
};

export default reviewSelectionStore;
